//ANGULAR
import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from '@angular/core'
import { formatDate } from '@angular/common'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
//ANGULAR MATERIALS
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'
import { DateAdapter, MatDatepickerInputEvent, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
//SERVICES
import { AppService, DialogService } from '../../../../../services'
//COMPONENTS
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'

import * as moment from 'moment'

const KEY = 'periodical-creation-dialog'

@Component({
	selector: 'atyl-periodical-creation',
	templateUrl: './periodical-creation.component.html',
	styleUrls: ['./periodical-creation.component.scss'],
	providers: [
		{ provide: LOCALE_ID, useValue: 'fr-FR' },
		{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
		},
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
		{
			provide: MAT_DATE_FORMATS, useValue: {
				parse: {
					dateInput: 'L',
				},
				display: {
					dateInput: 'L',
					monthYearLabel: 'MMM YYYY',
					dateA11yLabel: 'L',
					monthYearA11yLabel: 'MMM YYYY',
				},
			}
		},
	]
})
@Stringable({
	path: 'views/partials/layout/dialogs/periodical-creation-dialog',
	key: KEY,
})
export class PeriodicalCreationComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY)
	strings: any;
	dateFilter: any = (d: any): boolean => {
		/* Prevent Saturday and Sunday for select. */
		const day = d.day();

		return day !== 0 && day !== 6;
	}

	periode: any = "quotidien";
	dateDInput: any;
	dateFInput: any;
    monthMethod: any = "mensuel_weekday";
    weekDayLabel: string = "";
    weekDayObject: any = {};
    monthDayUnactive: boolean = false;
     
	errors: any = [];
	errorMessage: string;

	displayCustom = "quotidien"

	prettyMonthName: string = ""
	prettyDayName: string = ""
	prettyDayNumber: string = ""
	prettyWeekNumber:number = 1;
	
	repeatDayNumber = 1
	repeatMonthNumber = 1
	selectedDays = []

	_begin:Date;
	_end:Date;
		
		
	
	mensuelOptions:any[]=[
		{
			ID:1,
			label:"1er"
		},
		{
			ID:2,
			label:"2sd"
		},
		{
			ID:3,
			label:"3eme"
		},
		{
			ID:4,
			label:"4eme"
		},
		{
			ID:5,
			label:"dernier"
		}			
	];
	
	dayOptions:any[]=[
		{
			ID:1,
			label:"lundi"
		},
		{
			ID:2,
			label:"mardi"
		},
		{
			ID:3,
			label:"mercredi"
		},
		{
			ID:4,
			label:"jeudi"
		},
		{
			ID:5,
			label:"vendredi"
		},
		{
			ID:6,
			label:"samedi"
		},
		{
			ID:7,
			label:"dimanche"
		}		
	];
    mensuelWeekdayType:number;
    mensuelWeekdayDay:number;
    
	decimals: number=0;
	negative: number=0;
	
	constructor(
		private appService: AppService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<PeriodicalCreationComponent>,
		dialogService: DialogService,
		public dialog: MatDialog,
		changeDetectorRef: ChangeDetectorRef,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		// this.dialogRef.updateSize("600px", "300px")
		this.dialogRef.updateSize("600px", "450px")

		console.log("PeriodicalCreationComponent ngOnInit",this)
		if (this.data) {
			if (this.data.dateD) {
				console.log("PeriodicalCreationComponent ngOnInit",this.data.dateD instanceof Date);
				
				if (this.data.dateD instanceof Date)
					this._begin=this.data.dateD;
				
				if (this.data.dateD._d!=undefined && this.data.dateD._d instanceof Date) {
					this._getWeekLabel(this.data.dateD._d);
					this._begin=this.data.dateD._d;
				}
				
				this.dateDInput = formatDate(this.data.dateD, 'EEEE dd MMMM yyyy', 'fr');

				this.prettyDayName = formatDate(this.data.dateD, "EEEE", "fr")
				this.prettyDayNumber = formatDate(this.data.dateD, "dd", "fr")

				// We push the day name as selected
				this.selectedDays.push(this.prettyDayName)
			}
			if (this.data.dateF) {
				this.dateFInput = formatDate(this.data.dateF, 'dd/MM/yyyy', 'fr');
				
				if (this.data.dateF instanceof Date)
						this._end=this.data.end;
								
				if (this.data.dateF._d!=undefined && this.data.dateF._d instanceof Date) {
					
					this._end=this.data.dateF._d;
				}
				
			}
			if (this.data.periode) {
				this.periode = this.data.periode;
			}
			this.changeDetectorRef.detectChanges();
		}
	}

	selectPeriod(event: any) {
		this.displayCustom = event.value
		this.periode = event.value

		this.changeDetectorRef.detectChanges();
	}

	selectDayWeek(event: any) {
		const value = event.source.value

		if (this.selectedDays.includes(value)) {
			this.selectedDays = this.selectedDays.filter(day => day !== value)
		} else {
			this.selectedDays.push(value)
		}
	}

	setPeriod() {
		this.errors = [];
		this.errorMessage = "";
		console.log("setPeriod",this.data,this.periode,this.dateFInput,this.dateFInput)
				    
		// Check if all fields are valid and completed
		if (!this.periode) this.errors.push('Périodicité')
		if (!this.dateDInput) this.errors.push('Date de début')
        // Check if every date is valid
		
		if (!(this._begin instanceof Date))
				this.errors.push('Date incorrecte')					
		else if (!this.dateFInput || !this.dateFInput._d) {
			this.errors.push('Date de fin')
	  
			
		} else if (this.dateFInput._d < this._begin || this.dateFInput._d.getTime() == this._begin.getTime()) {
			this.errors.push('Date de fin invalide')
		} else if (this.periode == 'hebdomadaire' && (this.dateFInput.diff(this._begin, "days") + 1) < 7) {
			this.errors.push('Date de fin non cohérente');
		} else if (this.periode == 'mensuel' && (this.dateFInput.diff(this._begin, "days") + 1) < 29) {
			this.errors.push('Date de fin non cohérente');
		} 
		// else if (this.dateFInput.days() <= 0 || this.dateFInput.days() >= 6) {
		// 	this.errors.push("Date de fin invalide")
		// }

		// Display error or return all values
		if (this.errors.length > 0) {
			this.errorMessage = "<ul><li>" + this.errors.join("</li><li>") + "</li></ul>";
			this.changeDetectorRef.detectChanges();

			return
		}

		let nbDiff = null
		let interval = 1
		let monthNumber = this.prettyDayNumber

		if (this.periode === "quotidien") {
			let endDate = this.dateFInput.clone().add(1, "days")
			nbDiff = this.calculateNbConsults(this._begin, endDate, this.repeatDayNumber, "days")

			interval = this.repeatDayNumber
		} else if (this.periode === "hebdomadaire") {
			let nbDay = this.dateFInput.diff(this._begin, "days") + 1;
			// let nbWeek = this.dateFInput.diff(this.data.dateD, "week") + 1;
			const dayName = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
			const excludeDays = []

			for (let i = 0; i < dayName.length; i++) {
				if (!this.selectedDays.includes(dayName[i])) excludeDays.push(i)
			}

			nbDiff = this.calculateNbConsults(this._begin, this.dateFInput, this.repeatDayNumber, "days", excludeDays)

			// nbDiff = nbWeek * this.selectedDays.length;

			if (nbDay % 7 == 1) nbDiff = nbDiff + 1;
		} else if (this.periode === "mensuel") {
			let endDate = this.dateFInput.clone().add(1, "days")
			nbDiff = this.calculateNbConsults(this._begin, endDate, this.repeatMonthNumber, "month")
			// nbDiff = this.calculateNbConsults(this.data.dateD, this.dateFInput, this.repeatMonthNumber, "month")

			interval = this.repeatMonthNumber

			monthNumber = this.prettyDayNumber
		}
		this.weekDayObject={"countweekday":this.mensuelWeekdayType,
				"dayofweek":this.mensuelWeekdayDay};
		
		const dataReturn = {
			nbConsult: Math.round(nbDiff),
			periode: this.periode,
			dateF: this.dateFInput,
			interval: interval,
			selectedDays: this.selectedDays,
			monthNumber: monthNumber,
			weekNumber: Math.round(this.prettyWeekNumber),
			monthMethod: {
				
				method:this.monthMethod,
				parameters:this.weekDayObject	
			}
		}

		this.dialogRef.close(dataReturn);
	}

	calculateNbConsults(startDate, endDate, interval: number, unit: "month" | "days", exclude = []) {
		let currentDate:any = moment(startDate);
		let timeUnitCount = 0;
	
		while (currentDate.valueOf() < endDate.valueOf()) {

			// if (currentDate.day() > 0 && currentDate.day() < 6) timeUnitCount += 1
			if (!exclude.includes(currentDate.day())) timeUnitCount += 1
			
			currentDate.add(interval, unit)

			if (currentDate.valueOf() > endDate.valueOf()) break;
		}
	
		return timeUnitCount;
	}
	
	selectMonthMethod(event: any) {
		
		this.monthMethod = event.value
		
         this.monthDayUnactive=(this.monthMethod!='mensuel_day')
         
         if (!this.monthDayUnactive)
         		this.weekDayObject={};
         
		this.changeDetectorRef.detectChanges();
	}
	
	_getWeekLabel(begin:Date) {
		let weekCount:number=this._weekOfTheMonth(begin);
		
		
		this.weekDayObject={"countweekday":weekCount,"dayofweek":begin.getDay()};
		
		this.mensuelWeekdayType=weekCount;
		this.mensuelWeekdayDay=begin.getDay();
		this.weekDayObject={"countweekday":this.mensuelWeekdayType,"dayofweek":this.mensuelWeekdayDay};
		console.log("weekDayObject",this.weekDayObject)
		//this.weekDayLabel=this.strings.themonth + " "+ weekCount + lblWeek + " " + formatDate(begin,"EEEE", "fr");
		
	}
	
	_weekOfTheMonth(date) {
		  const day = date.getDate()
		  const weekDay = date.getDay()
		  let week = Math.ceil(day / 7)
		  /*
		  const ordinal = ['First', 'Second', 'Third', 'Fourth', 'Last']
		  const weekDays  = ['Sunday','Monday','Tuesday','Wednesday', 'Thursday','Friday','Saturday']
		  
		*/
		  // Check the next day of the week and if it' on the same month, if not, respond with "Last"
		  const nextWeekDay = new Date(date.getTime() + (1000 * 60 * 60 * 24 * 7))
		  if (nextWeekDay.getMonth() !== date.getMonth()) {
		    week = 5
		  }
		  return week;
	  	//return `${ordinal[week - 1]} ${weekDays[weekDay]}`
  	}

	
}
